import {useEffect, useState} from 'react';
import {useCookies} from "react-cookie";

function usePacProducts() {
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [editingPacProduct, setEditingPacProduct] = useState(null);
    const [addingPacProduct, setAddingPacProduct] = useState(false);
    const [error, setError] = useState(null);
    const apiRoot = process.env.REACT_APP_API_ROOT_URL;
    const [cookies] = useCookies(['idToken']);
    const apiHeaders = {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + cookies.idToken
    }

    const fetchProducts = async () => {
        const response = await fetch(`${apiRoot}/backoffice/pac-products?page=0&size=100`, {headers: apiHeaders});
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        return await response.json();
    };

    const getProducts = async () => {
        try {
            setLoading(true);
            const data = await fetchProducts();


            let allData = [...data.content];
            for (let i = 0; i < allData.length; i++) {
                delete allData[i].theirPublicKeyArn;
                delete allData[i].ourPrivateKeyArn;
                delete allData[i].clientSecretArn;
                const response = await fetch(apiRoot + '/backoffice/pac-products/' + allData[i].id + '/stores?page=0&size=100', {headers: apiHeaders});
                const storeData = await response.json();
                const storeContent = storeData.content;
                let stores = '';
                for (let i = 0; i < storeContent.length; i++) {
                    if (i > 0) {
                        stores += ', ';
                    }
                    stores += storeContent[i].name;
                }
                allData[i].stores = stores;
            }

            setProducts(allData);
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    async function handleSave(pacProduct, method = 'PUT') {
        try {
            let url = apiRoot + '/backoffice/pac-products';
            if (method === 'PUT') {
                url += '/' + pacProduct.id;
            }
            const response = await fetch(url, {
                method: method, headers: apiHeaders, body: JSON.stringify(pacProduct),
            });

            if (!response.ok) {
                throw new Error('Failed to save pac product');
            }
        } catch (error) {
            console.error('Error saving pac product:', error);
            setError('Failed to save pac product.');
        } finally {
            setEditingPacProduct(null);
            setAddingPacProduct(false);
            setLoading(true);
            getProducts().then(() => setLoading(false));
        }
    }

    useEffect(() => {
        getProducts();
    }, []);

    return {products, setProducts, handleSave, loading, setLoading, error, setError, addingPacProduct, setAddingPacProduct, editingPacProduct, setEditingPacProduct};
}

export default usePacProducts;
